import type {WizardData} from './index'

/**
 * The wizard's blank slate — what a brand-new tenant starts from before it has seen a screen.
 *
 * MUST stay empty for every field `extractOnboardingSetup` serialises. The backend infers the
 * onboarding funnel's "the user saved this screen" rows from `OnboardingWizard.setup`, and each
 * (tenant, sub-step) row is deduplicated forever — so a value seeded here lands in the blob on
 * the first render and permanently mis-stamps that sub-step as saved before the user acted.
 * Screen-level defaults (the pre-filled "Main Branch" row, the default subject frequency) belong
 * in Step2BasicSetup, which seeds them on arrival and marks them as pre-fills so they are not
 * mistaken for user input. See `onboardingSetup.test.ts`, which guards exactly this.
 */
export const initialData: WizardData = {
  mode: null,
  // Not part of extractOnboardingSetup — Step1 seeds a detected default as a prefill.
  country: null,
  // The Data Import choice screen was removed — every user goes through the manual flow.
  importType: 'manual',
  manualData: {
    branches: [],
    curriculums: [],
    levelsSameAcrossBranches: true,
    levelsCount: 0,
    levels: [],
    teachersCount: 0,
    teachers: [],
    classesCount: 0,
    classes: [],
    subjectsCount: 0,
    subjects: [],
    studentsCount: 0,
    students: [],
    venuesCount: 0,
    venues: [],
    timings: [],
    lessonPlanningData: undefined,
    defaultSubjectFrequency: undefined,
    defaultFrequencyPer: undefined,
  },
}
